<template>
  <SidePanel
    :initial_width="default_width"
    storage_key="news"
    @close="$emit('close')"
  >
    <div class="pdf-container">
      <iframe
        :src="pdfSrc"
        @load="onPdfLoad"
        width="100%"
        height="100%"
        frameborder="0">
      </iframe>
    </div>
  </SidePanel>
</template>
  
<script>
import { BlobServiceClient } from "@azure/storage-blob";
import SidePanel from "@/components/global/controls/SidePanel";
export default {
  name: "NewsWindow",
  components: { SidePanel },
  emits: ["close"],
  data() {
    return {
      pdfSrc: null,
    };
  },
  computed: {
    default_width() {
      return Math.round(window.innerWidth * 0.35);
    },
    accountName() {
      return this.$app.sltd.project.dto.storageName;
    }, 
  },
  mounted() {
    this.loadNewsPdf();
  },
  methods: {
    async loadNewsPdf() {
      try {
        const blobServiceClient = new BlobServiceClient(
          `https://${this.accountName}.blob.core.windows.net`
        );
        const containerClient = blobServiceClient.getContainerClient("default");

        for await (const blob of containerClient.listBlobsFlat({ prefix: "News/" })) {
          if (blob.name.endsWith(".pdf")) {
            const blockBlobClient = containerClient.getBlockBlobClient(blob.name);
            const url = blockBlobClient.url;
            this.pdfSrc = `${url}?toolbar=1&navpanes=0&scrollbar=0&view=FitH`;

            try {
              const nameKey = 'news_pdf';
              const openedKey = 'news_pdf_opened';
              const stored = localStorage.getItem(nameKey);
              if (!stored) {
                localStorage.setItem(nameKey, blob.name);
                localStorage.setItem(openedKey, 'false');
              } else if (stored !== blob.name) {
                // new PDF detected → replace name and reset opened flag
                localStorage.setItem(nameKey, blob.name);
                localStorage.setItem(openedKey, 'false');
              }
            } catch (e) {
              console.warn('localStorage unavailable for news PDF keys.', e);
            }
            break;
          }
        }

        if (!this.pdfSrc) {
          console.error("No PDF file found in the news directory.");
        }
      } catch (error) {
        console.error("Error loading news PDF", error);
      }
    },
    onPdfLoad() {
      try {
        localStorage.setItem('news_pdf_opened', 'true');
      } catch (e) {
        console.warn('localStorage unavailable for news_pdf_opened.', e);
      }
    }
  },
};
</script>
  
<style scoped>
.pdf-container {
  height: 100%;
  overflow: hidden;
}

.pdf-container iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
